import { render } from "./OverallBenefits.vue?vue&type=template&id=9905d786&scoped=true"
import script from "./OverallBenefits.vue?vue&type=script&lang=js"
export * from "./OverallBenefits.vue?vue&type=script&lang=js"

import "./OverallBenefits.vue?vue&type=style&index=0&id=9905d786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9905d786"]])

export default __exports__